// extracted by mini-css-extract-plugin
export default {"userPhoto":"CustomerModule_userPhoto__8bW10"};